var menu_trigger = document.querySelector('.nav-toggle'),
    nav = document.querySelector('.nav'),
    body = document.querySelector('body'),
    nav_icon = document.querySelectorAll('.mega-nav__trigger'),
    sub_icon = document.querySelectorAll('.nav__icon--sub');

menu_trigger.addEventListener('click', function() {
    // Toggle classes
    menu_trigger.classList.toggle('nav-toggle--active')
    nav.classList.toggle('nav--active')
    body.classList.toggle('overflow--hidden')
    body.classList.toggle('nav--open')

    // Accessibility
    if (menu_trigger.getAttribute('aria-expanded') === 'true') {
        menu_trigger.setAttribute('aria-expanded', 'false')
    } else {
        menu_trigger.setAttribute('aria-expanded', 'true')
    }
})

// Mobile mega nav
nav_icon.forEach(function(el) {
    el.addEventListener('click', function() {
        el.classList.toggle('nav__icon--active')
        el.closest('.nav__item').querySelector('.mega-nav').classList.toggle('mega-nav--active')
    })
})

sub_icon.forEach(function(el) {
    el.addEventListener('click', function() {
        el.classList.toggle('nav__icon--active')
        el.closest('.mega-nav__item').querySelector('.mega-nav__list--sub').classList.toggle('mega-nav__list--sub--active')
    })
})
